// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ApprovalChangeEventImpactedPosTableTabQueryVariables = Types.Exact<{
  changeEventId: Types.Scalars['ID']['input'];
}>;


export type ApprovalChangeEventImpactedPosTableTabQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', id: string, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, commitmentLineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, owner:
            | { __typename?: 'Commitment', id: string, accountingNumber: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, costChangeInCents: number, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, items: Array<{ __typename?: 'Item', id: string, displayName: string, fullCode: string }>, blueprintUrl: { __typename?: 'Url', path: string }, bidContractRevision?: { __typename?: 'BidContractRevision', id: string, version: string } | null | undefined, project:
                | { __typename?: 'StandaloneProject', id: string, name: string }
                | { __typename?: 'Region', id: string, name: string }
                | { __typename?: 'Market', id: string, name: string }
                | { __typename?: 'Community', id: string, name: string }
                | { __typename?: 'Subdivision', id: string, name: string }
                | { __typename?: 'Lot', id: string, name: string }
                | { __typename?: 'Structure', id: string, name: string }
                | { __typename?: 'Unit', id: string, name: string }
               }
            | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, costChangeInCents: number, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, items: Array<{ __typename?: 'Item', id: string, displayName: string, fullCode: string }>, blueprintUrl: { __typename?: 'Url', path: string } }
           }> } }>, impactedTrades: Array<{ __typename?: 'TradePartner', id: string, name: string }>, tradesToDraftCommitmentsFor: Array<{ __typename?: 'TradePartner', id: string, name: string }> } };

export type ChangeEventImpactedPosTableTab_ChangeEventLineItemFragment = { __typename?: 'ChangeEventLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, commitmentLineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, owner:
        | { __typename?: 'Commitment', id: string, accountingNumber: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, costChangeInCents: number, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, items: Array<{ __typename?: 'Item', id: string, displayName: string, fullCode: string }>, blueprintUrl: { __typename?: 'Url', path: string }, bidContractRevision?: { __typename?: 'BidContractRevision', id: string, version: string } | null | undefined, project:
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
           }
        | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, costChangeInCents: number, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, items: Array<{ __typename?: 'Item', id: string, displayName: string, fullCode: string }>, blueprintUrl: { __typename?: 'Url', path: string } }
       }> } };

export type ChangeEvent_CommitmentFragment = { __typename?: 'Commitment', id: string, accountingNumber: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, costChangeInCents: number, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, items: Array<{ __typename?: 'Item', id: string, displayName: string, fullCode: string }>, blueprintUrl: { __typename?: 'Url', path: string }, bidContractRevision?: { __typename?: 'BidContractRevision', id: string, version: string } | null | undefined, project:
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
   };

export type ChangeEvent_CommitmentChangeOrderFragment = { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, executionDate?: Types.Scalars['Date']['input'] | null | undefined, status: Types.CommitmentStatus, costChangeInCents: number, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, items: Array<{ __typename?: 'Item', id: string, displayName: string, fullCode: string }>, blueprintUrl: { __typename?: 'Url', path: string } };

export const ChangeEvent_CommitmentFragmentDoc = gql`
    fragment ChangeEvent_Commitment on Commitment {
  id
  accountingNumber
  tradePartner {
    ...Named
  }
  items {
    id
    displayName
    fullCode
  }
  executionDate
  status
  blueprintUrl {
    path
  }
  costChangeInCents
  bidContractRevision {
    id
    version
  }
  project {
    id
    name
  }
}
    ${NamedFragmentDoc}`;
export const ChangeEvent_CommitmentChangeOrderFragmentDoc = gql`
    fragment ChangeEvent_CommitmentChangeOrder on CommitmentChangeOrder {
  id
  accountingNumber
  tradePartner {
    ...Named
  }
  items {
    id
    displayName
    fullCode
  }
  executionDate
  status
  blueprintUrl {
    path
  }
  costChangeInCents
}
    ${NamedFragmentDoc}`;
export const ChangeEventImpactedPosTableTab_ChangeEventLineItemFragmentDoc = gql`
    fragment ChangeEventImpactedPosTableTab_ChangeEventLineItem on ChangeEventLineItem {
  id
  projectItem {
    id
    commitmentLineItems {
      id
      owner {
        ... on Commitment {
          ...ChangeEvent_Commitment
        }
        ... on CommitmentChangeOrder {
          ...ChangeEvent_CommitmentChangeOrder
        }
      }
    }
  }
}
    ${ChangeEvent_CommitmentFragmentDoc}
${ChangeEvent_CommitmentChangeOrderFragmentDoc}`;
export const ApprovalChangeEventImpactedPosTableTabDocument = gql`
    query ApprovalChangeEventImpactedPosTableTab($changeEventId: ID!) {
  changeEvent(id: $changeEventId) {
    id
    lineItems {
      ...ChangeEventImpactedPosTableTab_ChangeEventLineItem
    }
    impactedTrades {
      id
      name
    }
    tradesToDraftCommitmentsFor {
      id
      name
    }
  }
}
    ${ChangeEventImpactedPosTableTab_ChangeEventLineItemFragmentDoc}`;

/**
 * __useApprovalChangeEventImpactedPosTableTabQuery__
 *
 * To run a query within a React component, call `useApprovalChangeEventImpactedPosTableTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalChangeEventImpactedPosTableTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalChangeEventImpactedPosTableTabQuery({
 *   variables: {
 *      changeEventId: // value for 'changeEventId'
 *   },
 * });
 */
export function useApprovalChangeEventImpactedPosTableTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApprovalChangeEventImpactedPosTableTabQuery, ApprovalChangeEventImpactedPosTableTabQueryVariables> & ({ variables: ApprovalChangeEventImpactedPosTableTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApprovalChangeEventImpactedPosTableTabQuery, ApprovalChangeEventImpactedPosTableTabQueryVariables>(ApprovalChangeEventImpactedPosTableTabDocument, options);
      }
export function useApprovalChangeEventImpactedPosTableTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApprovalChangeEventImpactedPosTableTabQuery, ApprovalChangeEventImpactedPosTableTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApprovalChangeEventImpactedPosTableTabQuery, ApprovalChangeEventImpactedPosTableTabQueryVariables>(ApprovalChangeEventImpactedPosTableTabDocument, options);
        }
// @ts-ignore
export function useApprovalChangeEventImpactedPosTableTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApprovalChangeEventImpactedPosTableTabQuery, ApprovalChangeEventImpactedPosTableTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApprovalChangeEventImpactedPosTableTabQuery, ApprovalChangeEventImpactedPosTableTabQueryVariables>;
export function useApprovalChangeEventImpactedPosTableTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApprovalChangeEventImpactedPosTableTabQuery, ApprovalChangeEventImpactedPosTableTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApprovalChangeEventImpactedPosTableTabQuery | undefined, ApprovalChangeEventImpactedPosTableTabQueryVariables>;
export function useApprovalChangeEventImpactedPosTableTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApprovalChangeEventImpactedPosTableTabQuery, ApprovalChangeEventImpactedPosTableTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApprovalChangeEventImpactedPosTableTabQuery, ApprovalChangeEventImpactedPosTableTabQueryVariables>(ApprovalChangeEventImpactedPosTableTabDocument, options);
        }
export type ApprovalChangeEventImpactedPosTableTabQueryHookResult = ReturnType<typeof useApprovalChangeEventImpactedPosTableTabQuery>;
export type ApprovalChangeEventImpactedPosTableTabLazyQueryHookResult = ReturnType<typeof useApprovalChangeEventImpactedPosTableTabLazyQuery>;
export type ApprovalChangeEventImpactedPosTableTabSuspenseQueryHookResult = ReturnType<typeof useApprovalChangeEventImpactedPosTableTabSuspenseQuery>;
export type ApprovalChangeEventImpactedPosTableTabQueryResult = ApolloReactCommon.QueryResult<ApprovalChangeEventImpactedPosTableTabQuery, ApprovalChangeEventImpactedPosTableTabQueryVariables>;